import {
  LocalHospitalOutlined,
  Person,
  StarBorderOutlined,
} from "@mui/icons-material";
import { Stack } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ChipTabs from "../../../../components/ChipsTabs";
import Hero from "../../../../components/display/Hero";
import PageContentWrapper from "../../../../components/wrappers/PageContentWrapper";
import useUser from "../../../../hooks/useUser";
import { useIsMobile } from "../../../../utils/Functions";
import ClinicFeedbacks from "./components/ClinicFeedbacks";
import MasterRatingFilter from "./components/MasterRatingFilter";
import Ratings from "./components/Ratings";
import UserFeedbacks from "./components/UserFeedbacks";

export default function MasterHomePage() {
  const { roles } = useUser();
  const isMobile = useIsMobile();
  const content = [<UserFeedbacks />, <ClinicFeedbacks />, <Ratings />];

  const navigate = useNavigate();

  useEffect(() => {
    if (!roles.master) {
      navigate(-1);
    }
  }, [roles]);

  const labels = ["UserFeedbacks", "ClinicFeedbacks", "Ratings"];
  const icons = [<Person />, <LocalHospitalOutlined />, <StarBorderOutlined />];

  function Core() {
    return (
      <Stack spacing={2}>
        <MasterRatingFilter />
        <ChipTabs
          lsKey={"MASTER_FEEDBACKS_TABS"}
          tabContent={content}
          tabLabels={labels}
          icons={icons}
          wrapperMaxWidth="90vw"
        />
      </Stack>
    );
  }

  if (isMobile) {
    return (
      <PageContentWrapper>
        <Core />
      </PageContentWrapper>
    );
  }

  return (
    <>
      <Hero height="30vh" />
      <Stack spacing={2} padding={2}>
        <Core />
      </Stack>
    </>
  );
}
